import MorphTargetController from "../../../output/assets/objects/morph-target-controller.js";

function getInfluences(object) {
    let objInfl = object.morphTargetInfluences;

    if (!objInfl) {
        object.updateMorphTargets();
        objInfl = object.morphTargetInfluences;
    }

    return objInfl;
}

class ThreeMorphTargetController extends MorphTargetController {
    setInfluences(object, influences) {
        let objInfl = getInfluences(object);

        if (!objInfl) {
            return;
        }

        if (influences.length < objInfl.length) {
            objInfl.length = influences.length;
        }

        for (const [index, influence] of influences.entries()) {
            objInfl[index] = influence;
        }
    }

    setInfluence(object, index, influence) {
        let objInfl = getInfluences(object);

        if (!objInfl) {
            return;
        }

        objInfl[index] = influence;
    }

    clearInfluences(object) {
        const objInfl = object.morphTargetInfluences;

        if (!objInfl) {
            return;
        }

        objInfl.fill(0);
    }
}

export default ThreeMorphTargetController;
